// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./asstes/fonts/PublicSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./asstes/fonts/Lora-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./asstes/fonts/Lora-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./asstes/fonts/PublicSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./asstes/fonts/PublicSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./asstes/fonts/PublicSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./asstes/fonts/PublicSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./asstes/fonts/Lora-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./asstes/fonts/Lora-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./asstes/fonts/PublicSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./asstes/fonts/PublicSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./asstes/fonts/Lora-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./asstes/fonts/Lora-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./asstes/fonts/Lora-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./asstes/fonts/Lora-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1,
h2,
h3,
p {
  padding: 0px;
  margin: 0px !important;
}

@font-face {
  font-family: 'PublicSans-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lora-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PublicSans-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PublicSans-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lora-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'PublicSans-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lora-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Lora-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.main-loader {
  width: 50px;
  height: 50px;
  left: 50%;
  position: absolute;
  top: 50%;
  border: 4px solid #ffe594;
  border-radius: 50%;
  transform: rotate(50% -50%);
  animation: spin 1s linear infinite;
  border-top: 4px solid #ffffff;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B;0DAC2D;EAC3D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;0DACyD;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;0DAC+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC;0DAC6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;0DACqD;EACrD,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC;2DAC8D;EAC9D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B;2DACuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;2DACwD;EACxD,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nh1,\nh2,\nh3,\np {\n  padding: 0px;\n  margin: 0px !important;\n}\n\n@font-face {\n  font-family: 'PublicSans-Bold';\n  src: url('./asstes/fonts/PublicSans-Bold.woff') format('woff2'),\n    url('./asstes/fonts/PublicSans-Bold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Lora-SemiBold';\n  src: url('./asstes/fonts/Lora-SemiBold.woff2') format('woff2'),\n    url('./asstes/fonts/Lora-SemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'PublicSans-SemiBold';\n  src: url('./asstes/fonts/PublicSans-SemiBold.woff2') format('woff2'),\n    url('./asstes/fonts/PublicSans-SemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'PublicSans-Medium';\n  src: url('./asstes/fonts/PublicSans-Medium.woff2') format('woff2'),\n    url('./asstes/fonts/PublicSans-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Lora-Bold';\n  src: url('./asstes/fonts/Lora-Bold.woff2') format('woff2'),\n    url('./asstes/fonts/Lora-Bold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'PublicSans-Regular';\n  src: url('./asstes/fonts/PublicSans-Regular.woff2') format('woff2'),\n    url('./asstes/fonts/PublicSans-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Lora-Medium';\n  src: url('./asstes/fonts/Lora-Medium.woff2') format('woff2'),\n    url('./asstes/fonts/Lora-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Lora-Regular';\n  src: url('./asstes/fonts/Lora-Regular.woff2') format('woff2'),\n    url('./asstes/fonts/Lora-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n.main-loader {\n  width: 50px;\n  height: 50px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  border: 4px solid #ffe594;\n  border-radius: 50%;\n  transform: rotate(50% -50%);\n  animation: spin 1s linear infinite;\n  border-top: 4px solid #ffffff;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
